module.exports = __webpack_public_path__ + "img/4.822fc6d6.jpg";